import http from '@/http'
import { DraftPage } from '@/interfaces/admin'

export async function updateDraftPage (id: number, dto: DraftPage): Promise<DraftPage> {
  const { data } = await http.put(`/admin/draft-pages/${id}`, dto)
  return data
}
